import { ErrorBaseData } from '.'

export const healthPlanErrors: Record<string, ErrorBaseData> = {
  HealthPlanNotFoundException: {
    message: 'Plano de saúde não encontrado',
    description: 'Não foi possível encontrar o plano de saúde. Verifique as informações e tente novamente',
  },
  HealthPlanAlreadyExistsException: {
    message: 'Plano de saúde já cadastrado',
    description: 'Este plano de saúde já está cadastrado. Verifique as informações e tente novamente',
  },
}
